import { render, staticRenderFns } from "./EventCancellationPolicy_fr_packages.vue?vue&type=template&id=70ec6cdc&"
import script from "./EventCancellationPolicy_fr_packages.vue?vue&type=script&lang=js&"
export * from "./EventCancellationPolicy_fr_packages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports